import { get } from 'http'
import serviceAPI from 'services/service_api'

const getDocumentAPI = () =>
	serviceAPI(process.env.REACT_APP_API_URL || 'http://localhost:5000')

const defaultHeaders = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
}

export async function getDocumentTemplatesOptions(search = '') {
	try {
		const api = getDocumentAPI()
		const { data } = await api.get(
			`/documents/dashboard/filters/templates?search=${search}`
		)

		return Array.isArray(data) ? data : []
	} catch (error) {
		console.error('Erro ao buscar templates:', error)
		return []
	}
}

export async function getDocumentUsersOptions(search = '') {
	try {
		const api = getDocumentAPI()
		const { data } = await api.get(
			`/documents/dashboard/filters/users?search=${search}`
		)

		return Array.isArray(data) ? data : []
	} catch (error) {
		console.error('Erro ao buscar usuários:', error)
		return []
	}
}

export async function getDocumentWorkflowStagesOptions(search = '') {
	try {
		const api = getDocumentAPI()
		const { data } = await api.get(
			`/documents/dashboard/filters/workflow-stages`
		)

		return Array.isArray(data) ? data : []
	} catch (error) {
		console.error('Erro ao buscar etapas:', error)
		return []
	}
}

export async function getDashboardStats(payloadFilters) {
	const api = getDocumentAPI()
	return api.post('/documents/dashboard/stats', payloadFilters, {
		headers: defaultHeaders,
	})
}

export async function getDashboardArchivedCount(payloadFilters) {
	const api = getDocumentAPI()
	return api.post('/documents/dashboard/archived/count', payloadFilters, {
		headers: defaultHeaders,
	})
}

export async function getDashboardByTemplate(payloadFilters) {
	const api = getDocumentAPI()
	return api.post('/documents/dashboard/by-template', payloadFilters, {
		headers: defaultHeaders,
	})
}

export async function getDashboardByUser(payloadFilters) {
	const api = getDocumentAPI()
	return api.post('/documents/dashboard/by-user', payloadFilters, {
		headers: defaultHeaders,
	})
}

export async function getDashboardWorkflowStages(payloadFilters) {
	const api = getDocumentAPI()
	return api.post('/documents/dashboard/workflow-stages', payloadFilters, {
		headers: defaultHeaders,
	})
}
